var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"containerStyles"},[_c('div',{staticClass:"titleFontStyles",class:_vm.titleStyles},[_vm._v(" "+_vm._s(_vm.fieldTitle)+" ")]),_c('div',{staticClass:"seperatorContainer"},[_vm._v(" : ")]),_c('div',{staticClass:"valueFontStyles",class:_vm.valueStyles},[_vm._v(" "+_vm._s(_vm.fieldValue)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }